import { axiosConnectorInstance } from "../App";

export const getItems = (
  connectionUuid: string,
  folder: string,
  type: string
) => {
  return axiosConnectorInstance
    .get(`/connection/${connectionUuid}/folder`, {
      params: {
        [type === "infrakit" ? "infrakitFolderUuid" : "tcFolderPath"]: folder,
        folderType: type,
      },
    })
    .then((response) => response.data);
};

export const createMapping = (
  connectionUuid: string,
  infrakitFolderUuid: string,
  infrakitFolderPath: string,
  tcFolderId: string,
  tcFolderPath: string,
  leftUuid: string
) => {
  return axiosConnectorInstance
    .post(`/connection/${connectionUuid}/mapping`, {
      infrakitFolderUuid: infrakitFolderUuid,
      tcFolderId: tcFolderId,
      infrakitFolderPath: infrakitFolderPath,
      tcFolderPath: tcFolderPath,
      infraUuidPath: leftUuid,
    })
    .then((response) => response.data);
};

export const syncMapping = (
  connectionUuid: string,
  mappingUuid: string,
  way: string
) => {
  return axiosConnectorInstance
    .post(`/connection/${connectionUuid}/sync`, null, {
      params: {
        mappingUuid: mappingUuid,
        way,
      },
    })
    .then((response) => response.data);
};

export const autoSyncMapping = (
  connectionUuid: string,
  mappingUuid: string,
  way: string,
  delta: number
) => {
  const infrakitToken = localStorage.getItem("infrakitToken");
  const infrakitAccessToken = JSON.parse(infrakitToken || "{}").accessToken;
  const infrakitRefreshToken = JSON.parse(infrakitToken || "{}").refreshToken;

  return axiosConnectorInstance
    .post(`/connection/${connectionUuid}/job`, null, {
      params: {
        mapping_uuid: mappingUuid,
        way,
        delta,
        infra_token: infrakitAccessToken,
        infra_refresh_token: infrakitRefreshToken,
      },
    })
    .then((response) => response.data);
};

export const deleteAutoSync = (connectionUuid: string) => {
  return axiosConnectorInstance
    .delete(`/connection/${connectionUuid}/job`)
    .then((response) => response.data);
};

export const unmapMapping = (connectionUuid: string) => {
  return axiosConnectorInstance
    .delete(`/connection/${connectionUuid}/mapping`)
    .then((response) => response.data);
};

//function for cecking sync status
export const checkSyncStatus = (connectionUuid: string) => {
  return axiosConnectorInstance
    .get(`/connection/${connectionUuid}/sync/status`)
    .then((response) => response.data);
};
